var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{attrs:{"active":"churches"}}),_c('CrudList',{attrs:{"tableName":"church","tableNamePlural":"churches","defaultSort":"id","columns":_vm.columns,"dataModifier":_vm.dataModifier}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }